export { default as NewsAuthor } from './NewsAuthor'
export { default as NewsAuthorSkeleton } from './Skeleton'
